export default __webpack_public_path__ + "static/media/13.f287db87.jpg";